(function($) {

	/**
	 	jQuery Pluugin AroundPropertyMap
	 	Display map and filters to see what places is around the given location
	 	Usage example  :
	 	$("#gmap").AroundPropertyMap({
        	location: {
				lat: 43.602555,
				lng: 1.436806
			},
			zoomLevel: 15,
			radiusLevel: 500,
			filterContentSelector: "#filterContent",
			doNotDrawFilters: false,
	 	});
	 	*/

	 	$.AroundPropertyMap = function(element, options) {

        // PropertyFormSearch default options
        var defaults = {
        	//map options
        	propertyContent: 'Emplacement du bien',
        	location: {
        		lat: 43.602555,
        		lng: 1.436806
        	},
        	zoomLevel: 15,
			//search options
			radiusLevel: 500,
			//filter container options
			filterContentSelector: "#filterContent",
			doNotDrawFilters: false,
			filterHeaderStyle: 'list-style:none;',
			filterItemStyle: '',
			//Map infowindow options
			maxImgWidth: 150,
			maxImgHeight:150,
			styles : [
			{
				"featureType": "administrative.land_parcel",
				"stylers": [{"visibility": "off"}]
			},
			{
				"featureType": "administrative.neighborhood",
				"stylers": [{"visibility": "off"}]
			},
			{
				"featureType": "landscape.natural",
				"stylers": [{"color": "#e3cdb9"}]
			},
			{
				"featureType": "poi",
				"stylers": [{"color": "#cda177"}]
			},
			{
				"featureType": "poi",
				"elementType": "labels.text",
				"stylers": [{"visibility": "off"}]
			},
			{
				"featureType": "road",
				"elementType": "labels",
				"stylers": [{"visibility": "off"}]
			},
			{
				"featureType": "road.arterial",
				"elementType": "labels",
				"stylers": [{"visibility": "off"}]
			},
			{
				"featureType": "road.highway",
				"elementType": "labels",
				"stylers": [{"visibility": "off"}]
			},
			{
				"featureType": "road.local",
				"stylers": [{"visibility": "off"}]
			},
			{
				"featureType": "water",
				"stylers": [{"color": "#a0c0c6"}]
			},
			{
				"featureType": "water",
				"elementType": "labels.text",
				"stylers": [{"visibility": "off"}]
			}
			]
		};


        // Private vars
        var plugin = this;
        plugin.settings = {};
        plugin.types = [];
        plugin.map = null;
        plugin.mapId = null;
        plugin.cache = {};

        var $element = $(element),
        element = element;

        var availablePlacesTypes = [
        {
            'title': 'TRANSPORT',
            'value': 'transport',
            'content': [
            {
                'title': "Arrêt de bus",
                'value': 'bus_station',
            },
            {
                'title': "Aéroport",
                'value': 'airport',
            },
            {
                'title': "Gare",
                'value': 'train_station',
            },
            {
                'title': 'Métro',
                'value': 'subway_station'
            },
            {
                'title': "Parking",
                'value': 'parking',
            },
            {
                'title': "Parking pour camping-car",
                'value': 'rv_park',
            },
            {
                'title': "Location de véhicule",
                'value': 'car_rental',
            },
            ],
        },
        {
            'title': 'ÉDUCATION',
            'value': '*',
            'content': [
            {
                'title': "Bibliothèque",
                'value': 'library',
            },
            {
                'title': 'École',
                'value': 'school',
            },
            {
                'title': 'Université',
                'value': 'university',
            }
            ],
        },
        {
        	'title': 'SANTÉ',
        	'value': 'health',
        	'content': [
            {
                'title': 'Dentistes',
                'value': 'dentist',
            },
            {
                'title': 'Hôpitaux, cliniques',
                'value': 'hospital',
            },
            {
                'title': 'Kiné/Ostéopathe',
                'value': 'physiotherapist',
            },
            {
                'title': 'Médecins',
                'value': 'doctor',
            },
            {
                'title': 'Pharmacies',
                'value': 'pharmacy',
            },
          ],
      },
      {
       'title': 'COMMERCES',
       'value': 'store',
       'content': [
       {
        'title': "Alimentation/Restauration",
        'value': 'food',
    },
    {
        'title': "Animalerie",
        'value': 'pet_store',
    },
    {
        'title': 'Bijouterie',
        'value': 'jewelry_store',
    },
    {
        'title': "Blanchisserie",
        'value': 'laundry',
    },
    {
        'title': 'Boulangerie',
        'value': 'bakery',
    },
    {
        'title': "Boutique de vêtements",
        'value': 'clothing_store',
    },
    {
        'title': "Café",
        'value': 'cafe',
    },
    {
        'title': "Centre commercial",
        'value': 'shopping_mall',
    },
    {
        'title': "Concessionaire",
        'value': 'car_dealer',
    },
    {
        'title': "Dépanneur",
        'value': 'convenience_store',
    },
    {
        'title': "Épicerie ou supermarché",
        'value': 'grocery_or_supermarket',
    },
    {
        'title': "Fleuriste",
        'value': 'florist',
    },
    {
        'title': "Grand magasin",
        'value': 'department_store',
    },
    {
        'title': "Librairies",
        'value': 'book_store',
    },
    {
        'title': "Livraison de repas",
        'value': 'meal_delivery',
    },
    {
        'title': "Location de films",
        'value': 'movie_rental',
    },
    {
        'title': "Magasin d'alcool",
        'value': 'liquor_store',
    },
    {
        'title': "Magasin d'électronique",
        'value': 'electronics_store',
    },
    {
        'title': "Magasin de chaussures",
        'value': 'shoe_store',
    },
    {
        'title': "Magasin de meubles",
        'value': 'furniture_store',
    },
    {
        'title': 'Magasin de produits ménagers',
        'value': 'home_goods_store',
    },
    {
        'title': "Magasin de vélos",
        'value': 'bicycle_store',
    },        	
    {
        'title': "Plats à emporter",
        'value': 'meal_takeaway',
    },
    {
        'title': "Quincaillerie",
        'value': 'hardware_store',
    },
    {
        'title': "Restaurant",
        'value': 'restaurant',
    },        	
    {
        'title': "Salon de beauté",
        'value': 'beauty_salon',
    },
    {
        'title': "Salon de coiffure",
        'value': 'hair_care',
    },
  ]
},

{
   'title': 'SERVICES',
   'value': '*',
   'content': [   
    {
        'title': 'Assurance',
        'value': 'insurance_agency',
    },
    {
        'title': "Banque",
        'value': 'bank',
    },
    {
        'title': "Bureau de poste",
        'value': 'post_office',
    },
    {
        'title': "Caserne de pompiers",
        'value': 'fire_station',
    },
    {
        'title': "Couvreur",
        'value': 'roofing_contractor',
    },
    {
        'title': "Déménageur",
        'value': 'moving_company',
    },
    {    
        'title': "Distributeur automatique de billet",
        'value': 'atm',
    },
    {
        'title': "Électricien",
        'value': 'electrician',
    },
    {
        'title': "Entreprise de stockage",
        'value': 'storage',
    },
    {
      'title': "Garagiste",
      'value': 'car_repair',
    },
    {
        'title': "Hôtel de ville",
        'value': 'city_hall',
    },
    {
      'title': "Lave-auto",
      'value': 'car_wash',
    },
    {
        'title': "Plombier",
        'value': 'plumber',
    },
    {
      'title': "Poste de police",
      'value': 'police',
    },        
    {
      'title': "Serrurier",
      'value': 'locksmith',
    },
    {
        'title': "Station-essence",
        'value': 'gas_station',
    },
    ]
},
{
    'title': 'DIVERTISSEMENTS',
    'value': '*',
    'content': [
     {
        'title': "Aquarium",
        'value': 'aquarium',
    },
    {
        'title': "Bar",
        'value': 'bar',
    },
    {
        'title': "Boîte de nuit/Discotèque",
        'value': 'night_club',
    },
    {
        'title': "Bowling",
        'value': 'bowling_alley',
    },
    {
        'title': "Casino",
        'value': 'casino',
    },
    {
        'title': "Camping",
        'value': 'campground',
    },
    {
        'title': "Cinéma",
        'value': 'movie_theater',
    },
    {
        'title': "Galerie d'art",
        'value': 'art_gallery',
    },
    {
        'title': "Gymnase",
        'value': 'gym',
    },
    
    {
        'title': "Musée",
        'value': 'museum',
    },
     {
        'title': "Parc",
        'value': 'park',
    },
    {
        'title': "Parc d'attractions",
        'value': 'amusement_park',
    },
    {
        'title': "Spa",
        'value': 'spa',
    },
    {
        'title': "Stadium",
        'value': 'stadium',
    },
    {
        'title': "Zoo",
        'value': 'zoo',
    },
    ],
}
];

        //Public methods
        plugin.init = function() {
            // the plugin's final properties are the merged default and
            // user-provided options (if any)
            plugin.settings = $.extend({}, defaults, options);

            plugin.mapId = $element.prop('id');

            if(!plugin.mapId){
            	console.error("Map container must have an id ! ");
            }
            if(!$("#"+plugin.mapId)){
            	console.error("Can'find container with id:"+plugin.mapId+" ! ");	
            }

            setup();
        };


        //Private methods
        var setup = function(){
        	initFiltersContainer();
        	initMap();
        };

        var refresh = function(){
        	initMap();
        }

        var initMap = function(){
        	plugin.map = new google.maps.Map(
        		document.getElementById(plugin.mapId),
        		{
        			center: plugin.settings.location,
        			zoom: plugin.settings.zoomLevel,
        			mapTypeId: google.maps.MapTypeId.ROADMAP
        		}
        		);
        	plugin.map.setOptions({styles: plugin.settings.styles});
        	infowindow = new google.maps.InfoWindow();

        	var marker = new google.maps.Marker({
        		map: plugin.map,
        		position: plugin.settings.location,
        	});

        	google.maps.event.addListener(marker,'click',function(){
        		infowindow.setContent(plugin.settings.propertyContent);
        		infowindow.open(plugin.map,this);
        	});

        	if(plugin.types && plugin.types.length > 0){
        		var service = new google.maps.places.PlacesService(plugin.map);
        		jQuery.each(plugin.types,function(t,currentType){
        			if(currentType !== undefined){
        				if(plugin.cache[currentType]){
        					results = plugin.cache[currentType].results;
        					status = plugin.cache[currentType].status;
        					callbackNearbySeach(results,status,currentType);
        				}else{
        					service.nearbySearch(
        					{
        						location: plugin.settings.location,
        						radius: plugin.settings.radiusLevel,
        						types: [currentType],
        						rankby: 'distance'
        					},
        					function(results,status,pagination){
        						callbackNearbySeach(results,status,currentType);
                                if(pagination.hasNextPage){
                                    pagination.nextPage();
                                }
        					});
        				}
        			}
        		});
        	}
        }

        var callbackNearbySeach = function(results,status,type){
        	plugin.cache[type] = {
        		results: results,
        		status: status,
        	};
        	if(status===google.maps.places.PlacesServiceStatus.OK){
        		for(var i = 0; i < results.length; i++){
        			handlePlace(results[i]);
        		}
        	}else{
        		if(status != google.maps.places.PlacesServiceStatus.ZERO_RESULTS){
        			console.error("Error in callbackNearbySeach, status : " + status);
        		}
        	}
        };

        var handlePlace = function(place){
        	var placeLocation = place.geometry.location;
        	var gpmarker    = new google.maps.MarkerImage(place.icon, null, null, null, new google.maps.Size(25, 25));
        	var marker = new google.maps.Marker({
        		map: plugin.map,
        		position: placeLocation,
        		icon: gpmarker
        	});

        	google.maps.event.addListener(marker,'click',function(){
        		infowindow.setContent(drawContent(place));
        		infowindow.open(plugin.map,this);
        	});
        };

        var drawContent = function(place){
        	var content = $('<div></div>');
        	if(place.photos && place.photos.length > 0){
        		for(var p in place.photos){
        			var photo = place.photos[p];

        			if(typeof photo !== 'undefined'){
        				var url = photo.getUrl({
        					'maxWidth': plugin.settings.maxImgWidth,
        					'maxHeight': plugin.settings.maxImgHeight
        				});
        				content.append('<center><img class="map-infowindow-img img-rounded" src="'+url+'" maxWidth="'+photo.width+'" maxHeight="'+photo.height+'"/></center>');
        			}
        		}
        	}
        	content.append('<h5 class="map-infowindow-title">'+place.name+"</h5>");
        	content.append('<p class="map-infowindow-vicinity">'+place.vicinity+'</p>');

        	return content.html();
        };

        var initFiltersContainer = function(){
        	if(plugin.settings.doNotDrawFilters){
        		return null;
        	}

			//#filterContent
			var container = $(plugin.settings.filterContentSelector);
			if(!container){
				console.error("Can't find filter container with jQuery selector:"+plugin.settings.filterContentSelector);
			}


			var head = $('<ul class="prop-details-autourdecebien-nav"></ul>');
			var body = $('<div class="tab-content"></div>');
			isOneActive = false;

			for(var i in availablePlacesTypes){
				var filtreGroup = availablePlacesTypes[i];
				var currentId = "filter_"+i;
				var currentHeader = $('<li></li>');
				var currentBody = $('<div class="tab-pane" id="'+currentId+'"></div>');

				if(!isOneActive){
					currentHeader.addClass('active');
					currentBody.addClass('active');
					isOneActive = true;
				}
				currentHeader.append('<a href="#'+currentId+'" data-toggle="tab">'+filtreGroup.title+'</a>');
				head.append(currentHeader);

				

				var containerFilters = $('<ul class="aroundpropertymap-filter-ul" style="'+plugin.settings.filterHeaderStyle+'"></ul>');
                var nbShown = 0;
                nbElementPerColumn = filtreGroup.content.length / 3;
				for(var j in filtreGroup.content){
					var currentFilter = filtreGroup.content[j];
					var currentElem = $('<li class="aroundpropertymap-filter-li" style="'+plugin.settings.filterItemStyle+'"></li>');
					currentElem.html(drawCheckbox(currentFilter.title,currentFilter.value));
					currentElem.data('value',currentFilter.value);
					containerFilters.append(currentElem);
                    nbShown++;
                    if(nbShown >= nbElementPerColumn){
                        currentBody.append(containerFilters);
                        containerFilters = $('<ul class="aroundpropertymap-filter-ul" style="'+plugin.settings.filterHeaderStyle+'"></ul>');
                        nbShown = 0;
                    }
				}
				currentBody.append(containerFilters);
				body.append(currentBody);

			}

			var content = $('<div class=""></div>');
			content.append(head);
			content.append(body);
			container.append(content);

			//bind click events on checkbox
			$('.aroundpropertymap-checkbox-filter').on('click',function(){
				var checkeds = $("input[type='checkbox']");

				plugin.types = [];
				for(var c in checkeds){
					current = checkeds[c];
					if(current.checked && current.name !== undefined){
						plugin.types.push(current.name);
					}
				}
				refresh();
			});

		}

		var drawCheckbox = function(title,value){
			html = '<div class="checkbox"><label>';
			html += '<input type="checkbox" name="'+value+'" class="aroundpropertymap-checkbox-filter"/> ' + title;
			html += '</label></div>';
			return html;
		}

        // fire up the plugin!
        // call the "constructor" method
        plugin.init();
    }

    // add the plugin to the jQuery.fn object
    $.fn.AroundPropertyMap = function(options) {
        // iterate through the DOM elements we are attaching the plugin to
        return this.each(function() {

            // if plugin has not already been attached to the element
            if (undefined == $(this).data('AroundPropertyMap')) {
                // create a new instance of the plugin
                // pass the DOM element and the user-provided options as arguments
                var plugin = new $.AroundPropertyMap(this, options);

                // in the jQuery version of the element
                // store a reference to the plugin object
                // you can later access the plugin and its methods and properties like
                // element.data('AroundPropertyMap').publicMethod(arg1, arg2, ... argn) or
                // element.data('AroundPropertyMap').settings.propertyName
                $(this).data('AroundPropertyMap', plugin);
            }
        });

    }
})(jQuery);